import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import Input from '../ui/Input';
import usePersistedCollapse from '../../hooks/usePersistedCollapse';

// Generic, shared with every block type (see "Block capability contract"
// in PLAN.md): operates only on the `x`/`y` inches every block is
// guaranteed to have, never on type-specific fields. Renders nothing when
// no block is selected.
export default function PositionPanel({ selectedBlock, onUpdatePosition }) {
  const [collapsed, setCollapsed] = usePersistedCollapse('position');

  if (!selectedBlock) return null;

  return (
    <div className="ss-print__panel">
      <div className="ss-print__panel-header">
        <h3 className="ss-print__panel-title">Position (in)</h3>
        <button
          type="button"
          className="ss-print__lock-toggle"
          onClick={() => setCollapsed(!collapsed)}
          aria-expanded={!collapsed}
          aria-label={collapsed ? 'Expand position panel' : 'Collapse position panel'}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <ChevronRight size={16} aria-hidden="true" /> : <ChevronDown size={16} aria-hidden="true" />}
        </button>
      </div>

      {!collapsed && (
        <div className="ss-print__panel-row">
          <Input
            label="X"
            type="number"
            step={0.01}
            value={selectedBlock.x.toFixed(2)}
            onChange={(e) => onUpdatePosition('x', Number(e.target.value))}
          />
          <Input
            label="Y"
            type="number"
            step={0.01}
            value={selectedBlock.y.toFixed(2)}
            onChange={(e) => onUpdatePosition('y', Number(e.target.value))}
          />
        </div>
      )}
    </div>
  );
}
